<div class="image-visualization" *ngIf="hasImage()">
  <div [ngClass]="wrapperClass">
    <div class="table-scroll-wrapper">
      <div class="m-t-0 m-b-10 markdown-content" 
           [innerHTML]="imageSource | sanitizeMarkdown">
      </div>
    </div>
  </div>
  
  <!-- Error state -->
  <div class="image-error" *ngIf="showError">
    <div class="image-error-icon">⚠️</div>
    <div class="image-error-message">{{ errorMessage }}</div>
  </div>
</div>

